import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-wavesoft-device',
  templateUrl: './wavesoft-device.component.html',
  styleUrls: ['./wavesoft-device.component.css']
})
export class WavesoftDeviceComponent implements OnInit {

  @Input('paramFormWavesoftDevice') paramFormWavesoftDevice: FormGroup;
  @Input('readOnly') readOnly: boolean;

  constructor() {
  }

  ngOnInit() {
  }
}
